import { useState,useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import SEOHead from '../components/SEOHead';
import { useAuditLogger } from '../hooks/UseAuditLogger.js';

export default function About() {
  const { strings } = useLanguage();
  const map = {};  
  const [message, setMessage] = useState('');
  const { logEvent } = useAuditLogger();
  useEffect(() => {
       // Audit record selection
      logEvent({
        eventType: 'page.view',
        action: 'READ',
        requestData: { pageName: "About Association" }
      });
    }, []);

  return (
    <>
      <SEOHead routeId="about" slug="about" lang="ru" />
      <div className="main">
        <div className="content-wrapper">
          <section className="section">
            <div className="section-tag">
              О RPSwiss
            </div>
          </section>
          <div className="event_hero partners-hero">
            <div className="event_hero__content partners-hero__content" style={{ maxWidth: '100%', width: '100%' }}>
              <h1 className="event_hero__title">
                О <em className="event_hero__title-accent">нас</em>
              </h1>
              
              <style>{`
                .about-row {
                  display: flex;
                  flex-direction: column;
                  gap: 32px;
                  width: 100%;
                }
                .about-text-col {
                  flex: 1;
                  width: 100%;
                  max-width: none !important;
                }
                .about-photo-col {
                  flex: 0 0 380px;
                  width: 100%;
                  margin: 0;
                  display: flex;
                  flex-direction: column;
                }
                @media (min-width: 768px) {
                  .about-row {
                    flex-direction: row;
                    align-items: stretch;
                  }
                }
              `}</style>

              <div className="about-row">
                <div className="about-text-col">
                  <p className="about-story__text">
                    RPSwiss — профессиональная ассоциация русскоязычных специалистов, предпринимателей и руководителей,
                    живущих и работающих в Швейцарии.
                  </p>
                  <p className="about-story__text">
                    Мы создаём среду, в которой люди из разных профессиональных сфер могут знакомиться,
                    обмениваться знаниями и опытом, развивать свои компетенции, находить партнёров и создавать новые возможности.
                  </p>
                  <p className="about-story__text">
                    Ассоциация организует конференции, профессиональные и бизнес-встречи, экспертные эфиры и
                    образовательные форматы с участием специалистов из разных областей.
                  </p>
                  <p className="about-story__text">
                    RPSwiss сотрудничает с образовательными организациями, компаниями, экспертами и
                    профессиональными сообществами в Швейцарии и за её пределами, создавая совместные проекты и расширяя возможности для участников ассоциации.
                  </p>
                </div>

                <figure className="about-photo-col">
                  <img 
                    src="/img/nt_aboutus.jpeg" 
                    alt="Надежда Тейлор" 
                    style={{ width: '100%', flex: '1', minHeight: '0', borderRadius: '4px', objectFit: 'cover' }} 
                  />
                  <figcaption style={{ marginTop: '8px', textAlign: 'center', fontSize: '14px', color: 'rgba(255, 255, 255, 0.7)' }}>
                    Надежда Тейлор — Президент и основатель
                  </figcaption>
                </figure>
              </div>

            </div>
          </div>
        </div> 
      </div>
    </>
  );
}